export interface QueryResponse {
  data: any;
  status?: QueryResponseStatus;
  message?: string;
}

export enum QueryResponseStatus {
  SUCCEEDED = 'Succeeded',
  FAILED = 'Failed',
}
